import { Plugins } from '@leverege/plugin';
import sortBySortValueAndStringField from "./sortByValueAndStringField.js";
const factory = Plugins.createFactory('EnumValueSorter', {
  strategy: Plugins.ALL,
  pluginKey: 'sort',
  defaultObject: sortBySortValueAndStringField
});
export default factory;